import * as Scrivito from "scrivito"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { TeamsOverviewPageConnector } from "pages/teams-overview-page/TeamsOverviewPageConnector"

import { TeamsOverviewPageObjClass } from "./TeamsOverviewPageObjClass"

Scrivito.provideComponent(TeamsOverviewPageObjClass, () => {
  useScrivitoPage()
  return <TeamsOverviewPageConnector />
})
